<!-- 论文指导记录 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 36.13">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.53" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.53" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.69,3.86a3,3,0,0,0-3-2.95H8A3,3,0,0,0,5.07,3.86V23.57a3,3,0,0,0,2.95,3H27.74a3,3,0,0,0,3-3V11.71"
        />
        <path class="cls-3" d="M9.1,9.18l2,2a.62.62,0,0,0,.9,0l3.26-3.25" />
        <circle class="cls-3" cx="12.19" cy="17.67" r="2.49" />
        <line class="cls-3" x1="17.71" y1="9.8" x2="26.71" y2="9.8" />
        <line class="cls-3" x1="17.71" y1="17.67" x2="26.71" y2="17.67" />
        <ellipse class="cls-4" cx="30.6" cy="7.42" rx="1.41" ry="1.38" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 36.13">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.53" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.53" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.69,3.86a3,3,0,0,0-3-2.95H8A3,3,0,0,0,5.07,3.86V23.57a3,3,0,0,0,2.95,3H27.74a3,3,0,0,0,3-3V11.71"
        />
        <path class="cls-3" d="M9.1,9.18l2,2a.62.62,0,0,0,.9,0l3.26-3.25" />
        <circle class="cls-3" cx="12.19" cy="17.67" r="2.49" />
        <line class="cls-3" x1="17.71" y1="9.8" x2="26.71" y2="9.8" />
        <line class="cls-3" x1="17.71" y1="17.67" x2="26.71" y2="17.67" />
        <ellipse class="cls-4" cx="30.6" cy="7.42" rx="1.41" ry="1.38" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 34.15">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="25.56" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="25.56" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M29.82,4A2.78,2.78,0,0,0,27,1.23H8.47A2.78,2.78,0,0,0,5.69,4V22.57a2.79,2.79,0,0,0,2.78,2.78H27a2.79,2.79,0,0,0,2.78-2.78V11.4"
        />
        <path class="cls-3" d="M9.49,9l1.89,1.9a.6.6,0,0,0,.86,0L15.3,7.85" />
        <circle class="cls-3" cx="12.39" cy="17.01" r="2.34" />
        <line class="cls-3" x1="17.59" y1="9.6" x2="26.07" y2="9.6" />
        <line class="cls-3" x1="17.59" y1="17.01" x2="26.07" y2="17.01" />
        <ellipse class="cls-4" cx="29.85" cy="7.38" rx="1.33" ry="1.3" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.81px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.81px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke: #25a98c;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.45px;
    }
    .cls-4 {
      fill: #25a98c;
    }
  }
</style>
